import { useEffect, useState } from 'react'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { clientServices } from 'src/services/auth/client/client.service'
import { required, useGetIdentity, useNotify, useTranslate } from 'react-admin'
import { Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'

export const WrapperApplication = ({ index, setList, item, id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { identity } = useGetIdentity()
  const [isLoadingApplication, setLoadingApplication] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (item.clients.checkedClient) {
        try {
          setLoadingApplication(true)
          let allApplication = await clientServices.getApplicationByClient(item.clients.checkedClient)
          if (!allApplication) {
            notify('ra.notification.noApplicationClient', { type: 'error' })
            setLoadingApplication(false)
            return
          }
          // set all application by client so that later we can filter by the selected application
          const allApplicationToFilter = allApplication.map((item) => {
            return {
              application_id: item.application_id,
              config: item.config,
              application: item.application,
            }
          })

          const applications = {
            optionsApplication: allApplication.map((elem) => elem.application),
            checkedApplication: item.applications.checkedApplication
          }

          setList((prev) =>
            prev.map((item) =>
              item.id === id
                ? {
                    ...item,
                    applications,
                    allApplicationToFilter
                  }
                : item
            )
          )
        } catch (error) {
          notify('ra.notification.noApplicationClient', { type: 'error' })
        } finally {
          setLoadingApplication(false)
        }
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.clients.checkedClient])

  const onApplicationChange = (e) => {
    const applicationId = e.target.value

    setList((prev) => (
      prev.map((item) => (
        item.id === id ? {
          ...item,
          applications: {
            ...item.applications,
            checkedApplication: applicationId,
          },
          roles: { optionsRole: [], selectedRole: [] }
        } : item
      ))
    ))
  }

  if (identity?.is_superadmin) {
    return (
      <EditInputsWrap label={translate('ra.field.application')} md={12} required>
        {isLoadingApplication ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source={`aplications[${index}].application_id`}
            options={item.applications.optionsApplication}
            defaultValue={item.applications.checkedApplication}
            onChange={onApplicationChange}
            fullWidth
            optionsText={['long_name']}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
    )
  }
}
